var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeucardLending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f19334;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m467.34,401.34H119.66c-22.45,0-40.73,18.27-40.73,40.72v187.25c0,22.45,18.28,40.72,40.73,40.72h347.68c22.45,0,40.73-18.27,40.73-40.72v-187.25c0-22.45-18.28-40.72-40.73-40.72Zm-347.68,34.66h347.68c3.33,0,6.04,2.72,6.04,6.05v107.08H113.62v-107.08c0-3.33,2.71-6.05,6.04-6.05Zm347.68,199.36H119.66c-3.33,0-6.04-2.72-6.04-6.05v-45.51h359.77v45.51c0,3.33-2.71,6.05-6.04,6.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m715.03,278.66l-47.79-65.47c-5.65-7.7-16.48-9.44-24.22-3.78l-139.22,101.6c-7.73,5.64-9.43,16.48-3.8,24.21l12.21,16.74c3.33,4.56,8.57,7.12,14.01,7.12,1.67,0,3.36-.23,5.03-.74l174.79-52.88c5.36-1.63,9.64-5.76,11.41-11.08,1.8-5.33.89-11.18-2.42-15.73Zm-156.25,35.14l90.68-66.17,23.15,31.73-113.83,34.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m453.26,336.98l20.73.1h.08c7.34,0,13.88-4.61,16.33-11.52l61.17-172.04c1.88-5.3,1.09-11.17-2.14-15.77-3.23-4.6-8.49-7.34-14.11-7.37l-81.04-.4h-.08c-9.53,0-17.29,7.7-17.34,17.24l-.86,172.34c-.03,9.58,7.68,17.37,17.27,17.42Zm18.18-172.25l39.3.2-39.84,112.04.55-112.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeucardLending);
export default __webpack_public_path__ + "static/media/teucard_lending.f07b6d132776f45c710beb2319f7b8f3.svg";
export { ForwardRef as ReactComponent };